var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.68 39.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fc5b0b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.75,30.72c-2.14-3.38-3.38-8.2-4.74-15.43-1.09-5.75-5.99-10.07-11.78-10.18-7-.12-11.31,5.64-12.67,12.44C3.36,23.52,2.15,27.68,.25,30.72c-.66,1.01,.08,2.37,1.32,2.37H12.61c-.23,.66-.35,1.36-.23,2.14,.31,2.29,2.29,4.08,4.59,4.08,2.6,0,4.7-2.1,4.7-4.66,0-.54-.12-1.05-.27-1.55h11.04c1.24,0,1.98-1.36,1.32-2.37h0ZM7.59,18.16c.47-2.33,2.53-9.95,9.41-9.95s8.94,7.62,9.41,9.95c.93,4.82,1.94,8.67,3.42,11.82H4.17c1.48-3.15,2.49-7,3.42-11.82h0Zm10.96,16.48c0,.85-.7,1.55-1.55,1.55s-1.55-.7-1.55-1.55,.7-1.55,1.55-1.55c.85,0,1.55,.7,1.55,1.55Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.22,
    cy: 4.46,
    r: 4.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2ffcd809dfe45a7b0646a2b704a3fcb6.svg";
export { ForwardRef as ReactComponent };